import React, { Component } from 'react'
import axios from 'axios'
import styled from 'styled-components'

import { API_BASE_URL } from 'config'

import StarRating from 'components/StarRating'
import ButtonGradientV2 from 'components/ButtonGradientV2'

const RATING_ENDPOINT = `${API_BASE_URL}/public/subscribe-price-list/feedback/`

/**
 * Conteúdo do inquérito de avaliação da adesão (rating).
 *
 * Réplica em React do rating.php + main.js (jQuery) do WordPress antigo, para
 * poder ser servido isolado e embebido num iframe do projeto pai.
 *
 * O token e o subscription chegam por props (lidos do URL pelo RatingStandalone)
 * e vão no payload do POST — sem eles não é possível submeter.
 *
 * Props:
 *  - subscription: string (obrigatório para submeter).
 *  - token: string (obrigatório para submeter).
 *  - onSuccess: callback chamado após o POST ter sucesso.
 */
export default class RatingContent extends Component {
  state = {
    rating_1: 0,
    rating_2: 0,
    rating_3: 0,
    observations: '',
    authorize: false,
    loading: false,
    error: '',
  }

  setRating = (key, value) => this.setState({ [key]: value, error: '' })

  // As 3 avaliações são obrigatórias (comentário e checkbox são opcionais),
  // tal como validava o main.js antigo.
  validate = () => {
    const { rating_1, rating_2, rating_3 } = this.state
    if (!rating_1 || !rating_2 || !rating_3) {
      return 'Avalie por favor todas as questões.'
    }
    return ''
  }

  handleSubmit = (e) => {
    e.preventDefault()

    const { subscription, token, onSuccess } = this.props
    const { rating_1, rating_2, rating_3, observations, authorize } = this.state

    const error = this.validate()
    if (error) {
      this.setState({ error })
      return
    }

    this.setState({ loading: true, error: '' })

    axios
      .post(RATING_ENDPOINT, {
        subscription,
        feedback_token: token,
        rating_1,
        rating_2,
        rating_3,
        observations,
        authorize,
      })
      .then(() => {
        this.setState({ loading: false })
        onSuccess && onSuccess()
      })
      .catch((err) => {
        // A API devolve validações em `non_field_errors` (ex.: quando a
        // avaliação já foi submetida antes -> "Avaliação já efetuada").
        // Mostramos essa mensagem; para qualquer outro erro, uma genérica.
        const data = err && err.response && err.response.data
        const apiMessage =
          data && data.non_field_errors && data.non_field_errors[0]
        this.setState({
          loading: false,
          error: apiMessage || 'Ocorreu um erro tente novamente mais tarde.',
        })
      })
  }

  render() {
    const {
      rating_1,
      rating_2,
      rating_3,
      observations,
      authorize,
      loading,
      error,
    } = this.state

    return (
      <Form onSubmit={this.handleSubmit}>
        <Title>Avalie o seu pedido de adesão</Title>
        <FixedLabel>Como correu a sua adesão?</FixedLabel>

        <Question>
          <StarRating
            name='rating_1'
            value={rating_1}
            onChange={(v) => this.setRating('rating_1', v)}
          />
          <StarLabel>Tempo de resposta</StarLabel>
        </Question>

        <Question>
          <StarRating
            name='rating_2'
            value={rating_2}
            onChange={(v) => this.setRating('rating_2', v)}
          />
          <StarLabel>Qualidade do atendimento</StarLabel>
        </Question>

        <Question>
          <StarRating
            name='rating_3'
            value={rating_3}
            onChange={(v) => this.setRating('rating_3', v)}
          />
          <StarLabel>Formalização do contrato</StarLabel>
        </Question>

        <FixedLabel>Comentário</FixedLabel>
        <TextArea
          rows='4'
          value={observations}
          onChange={(e) => this.setState({ observations: e.target.value })}
          placeholder='Escreva um comentário e ajude-nos a melhorar.'
        />

        <CheckboxLabel>
          <input
            type='checkbox'
            checked={authorize}
            onChange={(e) => this.setState({ authorize: e.target.checked })}
          />
          Autorizo que o meu comentário seja divulgado
        </CheckboxLabel>

        {error ? <ErrorText>{error}</ErrorText> : null}

        <ButtonGradientV2
          style={{ width: '140px' }}
          type='submit'
          disabled={loading}>
          Submeter
        </ButtonGradientV2>
      </Form>
    )
  }
}

const Form = styled.form`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  width: 100%;
  padding: 16px;
`

const Title = styled.h3`
  color: #1d1e22;
  font-family: Nunito;
  font-size: 18px;
  font-weight: 700;
  line-height: 24px;
  margin: 0;
  text-align: left;
  text-transform: unset;
  letter-spacing: unset;
`

const FixedLabel = styled.label`
  color: #1d1e22;
  font-family: Nunito;
  font-size: 14px;
  font-weight: 700;
  line-height: 20px;
`

const Question = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
`

const StarLabel = styled.span`
  color: #3e3e3e;
  font-family: Nunito;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
`

const TextArea = styled.textarea`
  width: 100%;
  padding: 10px;
  align-self: stretch;
  border: 1px solid #ececec;

  color: #3e3e3e;
  font-family: Nunito;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  resize: vertical;

  &::placeholder {
    color: #616161;
  }
`

const CheckboxLabel = styled.label`
  display: flex;
  align-items: center;
  gap: 8px;
  color: #3e3e3e;
  font-family: Nunito;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  cursor: pointer;
`

const ErrorText = styled.span`
  color: #c00000;
  font-family: Nunito;
  font-size: 13px;
  font-weight: 600;
  line-height: 18px;
`



// WEBPACK FOOTER //
// ./src/components/RatingContent/index.js